var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21767_204638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.986775 3.45294C0.940095 3.4531 0.894328 3.44001 0.854792 3.41519C0.815255 3.39038 0.783572 3.35485 0.763422 3.31274C0.743273 3.27064 0.735484 3.22368 0.740962 3.17732C0.74644 3.13096 0.764959 3.08711 0.794368 3.05086L3.23646 0.534765C3.25478 0.51362 3.27974 0.499331 3.30725 0.494244C3.33476 0.489157 3.36318 0.493573 3.38785 0.506768C3.41252 0.519963 3.43197 0.541153 3.44301 0.566859C3.45405 0.592566 3.45602 0.621261 3.4486 0.648236L2.97498 2.13322C2.96102 2.1706 2.95633 2.21081 2.96131 2.2504C2.9663 2.28999 2.98082 2.32777 3.00362 2.36052C3.02642 2.39326 3.05682 2.41999 3.09222 2.4384C3.12762 2.45682 3.16696 2.46637 3.20686 2.46624H4.93359C4.98027 2.46608 5.02604 2.47917 5.06557 2.50398C5.10511 2.5288 5.13679 2.56433 5.15694 2.60643C5.17709 2.64854 5.18488 2.6955 5.1794 2.74186C5.17392 2.78822 5.15541 2.83207 5.126 2.86832L2.68391 5.38441C2.66559 5.40556 2.64062 5.41985 2.61311 5.42493C2.5856 5.43002 2.55718 5.42561 2.53251 5.41241C2.50784 5.39922 2.48839 5.37803 2.47735 5.35232C2.46632 5.32661 2.46434 5.29792 2.47176 5.27094L2.94538 3.78595C2.95935 3.74858 2.96404 3.70837 2.95905 3.66878C2.95406 3.62919 2.93955 3.59141 2.91675 3.55866C2.89394 3.52591 2.86354 3.49919 2.82814 3.48078C2.79274 3.46236 2.75341 3.45281 2.71351 3.45294H0.986775Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.493352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21767_204638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.92022,
    height: 5.92022,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevin);
export default __webpack_public_path__ + "static/media/levin.ef616029e65112de22458edf864e2927.svg";
export { ForwardRef as ReactComponent };